import React from "react";

import {Ethers5Adapter} from "@reown/appkit-adapter-ethers5";
import {HelmetProvider} from "react-helmet-async";
import {createAppKit} from "@reown/appkit/react";
import "reflect-metadata"

import { CHAIN_ENVIRONMENT, CURRENT_SUPPORTED_APP_KIT_NETWORKS, CURRENT_SUPPORTED_RPC_URLS} from "./web3/chains";
import {GlobalModalsProvider} from "./layouts";
import Routers from "./routes";
import './i18';

const currentEnvironment = process.env.REACT_APP_NETWORK_ENVIRONMENT ?? CHAIN_ENVIRONMENT.MAINNET;
const projectId = process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID

if (projectId === undefined) {
    throw new Error("Wallet Connect Project ID is not defined");
}

createAppKit({
    projectId,
    adapters: [new Ethers5Adapter()],
    defaultNetwork: CURRENT_SUPPORTED_APP_KIT_NETWORKS[currentEnvironment][1],
    customRpcUrls: CURRENT_SUPPORTED_RPC_URLS[currentEnvironment],
    networks: CURRENT_SUPPORTED_APP_KIT_NETWORKS[currentEnvironment],
    metadata: {
        name: "KOMPETE: The Ultimate Gaming Platform",
        description: "KOMPETE is a multiplayer gaming platform with multiple games of different genres. Jump seamlessly with your avatar from game to game on the main menu. Play Early Access on PC, Android, and iOS!",
        url: window.location.origin,
        icons: [`${window.location.origin}/images/K_LOGO.png`],
    },
    features: {
        connectMethodsOrder: ["wallet"],
        swaps: false,
        analytics: true,
    },
    featuredWalletIds: [
        "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
        "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
        "541d5dcd4ede02f3afaf75bf8e3e4c4f1fb09edb5fa6c4377ebf31c2785d9adf",
        "a797aa35c0fadbfc1a53e7f675162ed5226968b44a19ee3d24385c64d1d3c393",
    ],
    enableWalletGuide: false,
    enableNetworkSwitch: false,
});

function App() {
    return (
        <React.Fragment>
            <HelmetProvider>
                <GlobalModalsProvider>
                    <Routers/>
                </GlobalModalsProvider>
            </HelmetProvider>
        </React.Fragment>
    );
}

export default App;
